import AbstractTrack from '../abstract.track';
import { AngularServices } from '../../../../modules/core';
import { PnEvents } from '../../../../realtime';
import { GrowthBookFeatures } from '../../../../modules/core/constants/growthbook';
export default class RealtimeFirstParticipantAppearTrack extends AbstractTrack {
    constructor() {
        super(...arguments);
        this.eventNameSegment = 'First Participant Appears In Queue';
    }
    start() {
        const hasBeenAlreadyAppearedMap = {};
        const pn = this.$injector.get(AngularServices.Pn);
        const growthbookFactory = this.$injector.get(AngularServices.GrowthbookFactory);
        pn.on(PnEvents.Join, (person) => {
            const isDoctor = pn.isDoctor();
            const isPatient = pn.isPatient();
            if (!isDoctor && !isPatient) {
                return;
            }
            if (isDoctor) {
                const shouldHideProviderJoinEvent = growthbookFactory.getFeature(GrowthBookFeatures.HideProviderJoinEventTracking).value;
                if (shouldHideProviderJoinEvent) {
                    return;
                }
            }
            if (!hasBeenAlreadyAppearedMap[person.uuid]) {
                hasBeenAlreadyAppearedMap[person.uuid] = true;
                this.trackSegment({
                    person_room_id: person.roomId,
                    person_uuid: person.uuid,
                });
            }
        });
    }
}
